<template>
  <img
    :src="symbolId"
    alt=""
    loading="lazy"
    decoding="async"
    width="18"
    height="12"
    class="base-gov-icon align-middle w-[18px] h-[12px]"
  />
</template>

<script>
  import { defineComponent, computed } from 'vue'

  export default defineComponent({
    name: 'GovIcon',
    props: {
      prefix: {
        type: String,
        default: 'icon-gov',
      },
      name: {
        type: String,
        required: true,
      },
      color: {
        type: String,
        default: '#C9CFDB',
      },
    },
    setup(props) {
      const symbolId = computed(
        () =>
          `https://assets.jctrans.com/assets/image/country/${props.name}.svg`,
      )

      return {
        symbolId,
      }
    },
  })
</script>

<style>
  .base-gov-icon {
    fill: currentcolor;
  }
</style>
